import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-LN/report/SafeDrivingReport/.eu';

export interface SafeDrivingReportProps {
  vin: string;
}

export default function SafeDrivingReport({vin}: SafeDrivingReportProps) {
  return (
    <>
      <Environment.Eu>
        <Environment.Kia>
          <Eu vin={vin} />
        </Environment.Kia>
      </Environment.Eu>
    </>
  );
}
